import {
    CREATE_SIZE_INFO_REQUEST,
    CREATE_SIZE_INFO_SUCCESS,
    CREATE_SIZE_INFO_FAILURE,
    DELETE_SIZE_INFO_REQUEST,
    DELETE_SIZE_INFO_SUCCESS,
    DELETE_SIZE_INFO_FAILURE,
    FETCH_SINGLE_SIZE_INFO_REQUEST,
    FETCH_SINGLE_SIZE_INFO_SUCCESS,
    FETCH_SINGLE_SIZE_INFO_FAILURE,
    FETCH_SIZE_INFO_REQUEST,
    FETCH_SIZE_INFO_SUCCESS,
    FETCH_SIZE_INFO_FAILURE,
    UPDATE_SIZE_INFO_REQUEST,
    UPDATE_SIZE_INFO_SUCCESS,
    UPDATE_SIZE_INFO_FAILURE,
    RESET_SIZE_INFO_INFO,
    CREATE_SIZE_INFO_FORM,
    UPDATE_SIZE_INFO_FORM,
    NAVIGATE_SIZE_RATIO,
    NAVIGATE_SIZE_INFO,
    FETCH_GENDER_SUCCESS,
    FETCH_SIZE_INFO_INVOICE_REQUEST,
    FETCH_SIZE_INFO_INVOICE_SUCCESS,
    FETCH_SIZE_INFO_INVOICE_FAILURE,
    RESET_SIZE_INFO_INVOICE,
    NAVIGATE_SIZE_RATIO_MEASUREMENT,
    FETCH_SIZE_INFO_MES_REQUEST,
    FETCH_SIZE_INFO_MES_SUCCESS,
    FETCH_SIZE_INFO_MES_SINGLE_GET_SUCCESS
} from './sizeInfo.actionsType';

export const SIZE_INFO = 'sizeInfo';

let initialState = {
    loading: false,
    sizeInfo: [],
    gender: [],
    sizeInfoform: {
        fldS01: '',
        fldS02: '',
        fldS03: '',
        fldS04: '',
        fldS05: '',
        fldS06: '',
        fldS07: '',
        fldS08: '',
        fldS09: '',
        fldS10: '',
        fldS11: '',
        fldS12: '',
        fldS13: '',
        fldS14: '',
        fldS15: '',
        fldS16: '',
        fldS17: '',
        fldS18: ''
    },
    selectedState: {},
    errorMessage: '',
    sizeInfoId: {},
    sizeInfoIdMes: {},
    isSizeInfoRatio: false,
    isSizeInfoMes: false,
    sizeInvoice: [],
    sizeMesGetData: []
};

export let sizeInfoReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_SIZE_INFO_REQUEST:
        case CREATE_SIZE_INFO_REQUEST:
        case UPDATE_SIZE_INFO_REQUEST:
        case FETCH_SINGLE_SIZE_INFO_REQUEST:
        case DELETE_SIZE_INFO_REQUEST:
        case FETCH_SIZE_INFO_INVOICE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_SIZE_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeInfo: updatePayload
            };
        case FETCH_GENDER_SUCCESS:
            return {
                ...state,
                loading: false,
                gender: updatePayload
            };
        case CREATE_SIZE_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeInfoform: {
                    fldS01: '',
                    fldS02: '',
                    fldS03: '',
                    fldS04: '',
                    fldS05: '',
                    fldS06: '',
                    fldS07: '',
                    fldS08: '',
                    fldS09: '',
                    fldS10: '',
                    fldS11: '',
                    fldS12: '',
                    fldS13: '',
                    fldS14: '',
                    fldS15: '',
                    fldS16: '',
                    fldS17: '',
                    fldS18: ''
                }
            };
        case UPDATE_SIZE_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeInfoform: {
                    fldS01: '',
                    fldS02: '',
                    fldS03: '',
                    fldS04: '',
                    fldS05: '',
                    fldS06: '',
                    fldS07: '',
                    fldS08: '',
                    fldS09: '',
                    fldS10: '',
                    fldS11: '',
                    fldS12: '',
                    fldS13: '',
                    fldS14: '',
                    fldS15: '',
                    fldS16: '',
                    fldS17: '',
                    fldS18: ''
                }
            };
        case FETCH_SINGLE_SIZE_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeInfoform: updatePayload
            };
        case DELETE_SIZE_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeInfoform: {}
            };
        case FETCH_SIZE_INFO_MES_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeMesGetData: updatePayload
            }
        case FETCH_SIZE_INFO_MES_SINGLE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeMesEdit: updatePayload
            }
        case FETCH_SIZE_INFO_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeInvoice: updatePayload
            };
        case RESET_SIZE_INFO_INVOICE:
            return {
                ...state,
                sizeInvoice: []
            };
        case RESET_SIZE_INFO_INFO:
            return {
                ...state,
                sizeInfoform: {
                    fldS01: '',
                    fldS02: '',
                    fldS03: '',
                    fldS04: '',
                    fldS05: '',
                    fldS06: '',
                    fldS07: '',
                    fldS08: '',
                    fldS09: '',
                    fldS10: '',
                    fldS11: '',
                    fldS12: '',
                    fldS13: '',
                    fldS14: '',
                    fldS15: '',
                    fldS16: '',
                    fldS17: '',
                    fldS18: ''
                }
            };
        case CREATE_SIZE_INFO_FORM:
        case UPDATE_SIZE_INFO_FORM:
            return {
                ...state,
                loading: false,
                sizeInfoform: {
                    ...state.sizeInfoform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_SIZE_INFO_FAILURE:
        case CREATE_SIZE_INFO_FAILURE:
        case UPDATE_SIZE_INFO_FAILURE:
        case FETCH_SINGLE_SIZE_INFO_FAILURE:
        case DELETE_SIZE_INFO_FAILURE:
        case FETCH_SIZE_INFO_INVOICE_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_SIZE_RATIO:
            return {
                ...state,
                isSizeInfoRatio: true,
                sizeInfoId: updatePayload.sizeInfoId
            };
        case NAVIGATE_SIZE_RATIO_MEASUREMENT:
            return {
                ...state,
                isSizeInfoRatio: false,
                isSizeInfoMes: true,
                sizeInfoIdMes: updatePayload.sizeInfoId
            }
        case NAVIGATE_SIZE_INFO:
            return {
                ...state,
                isSizeInfoRatio: false,
                isSizeInfoMes: false,

            };
        default:
            return state;
    }
};
